import { get } from "lodash-es";
import axios from "axios";

export default {
  state: {
    chips: [],
    chipForModify: null,
  },
  mutations: {
    setChips(state, payload) {
      state.chips = payload;
    },
    setChipForModify(state, payload) {
      state.chipForModify = payload;
    },
  },
  actions: {
    async getChips(context) {
      const resp = await axios.post("/execute", {
        method: "CLI.GetChips",
        parameters: [],
      });
      if (resp.data.ok) {
        context.commit("setChips", get(resp, "data.result[0]"));
      }
      return resp.data;
    },
  },
  getters: {
    getChips(state) {
      return state.chips;
    },
  },
};
